import { render, staticRenderFns } from "./AlarmRecordsSection.vue?vue&type=template&id=6a532b1e&scoped=true&"
import script from "./AlarmRecordsSection.vue?vue&type=script&lang=js&"
export * from "./AlarmRecordsSection.vue?vue&type=script&lang=js&"
import style0 from "./AlarmRecordsSection.vue?vue&type=style&index=0&id=6a532b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a532b1e",
  null
  
)

export default component.exports